import { css } from "styled-components";

/** New responsive rules should use these two widths only. */
export const PHONE_MAX_WIDTH = 768;
export const TABLET_MAX_WIDTH = 1024;

/** Height of the phone bottom bar, excluding the safe-area inset. */
export const MOBILE_NAV_HEIGHT = 72;

/** Gap kept above a phone bottom sheet so the page behind it stays visible. */
export const MOBILE_SHEET_TOP_MARGIN = 60;

/** Top padding of the phone page scroller (RootLayout). Sticky page content offsets by it. */
export const MOBILE_PAGE_PADDING_TOP = 16;

/**
 * Height of a bar docked to the bottom of a phone screen on pages that hide the bottom bar (a primary action
 * plus its summary), excluding the safe-area inset. Mark such a bar `data-docked-bar`; RootLayout then
 * leaves this much room under the page, so the footer's link still scrolls clear above the bar.
 */
export const MOBILE_DOCKED_BAR_HEIGHT = 76;

/** Horizontal page gutter on phones. */
export const MOBILE_GUTTER = 20;

/** Minimum hit area for secondary controls (back, close, icon actions). */
export const TAP_TARGET = 44;

/** Minimum hit area for primary actions and bottom-bar items. */
export const TAP_TARGET_PRIMARY = 48;

/** Top corner radius of phone bottom sheets. */
export const SHEET_RADIUS = 20;

/** Device safe-area insets; 0 where the browser reports none. Needs `viewport-fit=cover`. */
export const SAFE_AREA = {
	top: "env(safe-area-inset-top, 0px)",
	right: "env(safe-area-inset-right, 0px)",
	bottom: "env(safe-area-inset-bottom, 0px)",
	left: "env(safe-area-inset-left, 0px)",
} as const;

type CssArgs = Parameters<typeof css>;

/** Styles that apply at the phone breakpoint and below. */
export const mediaPhone = (...args: CssArgs) => css`
	@media (max-width: ${PHONE_MAX_WIDTH}px) {
		${css(...args)}
	}
`;

/** Styles that apply at the tablet breakpoint and below. */
export const mediaTablet = (...args: CssArgs) => css`
	@media (max-width: ${TABLET_MAX_WIDTH}px) {
		${css(...args)}
	}
`;
